import { EventType } from 'Utility/GameEvent/GameEvents';
import { getGameEmitter } from '@platform/Utility/GameEvent/CreateGameEmitter';

export function emitGameEvent(event: EventType) {
    const emitter = getGameEmitter();
    if (emitter) emitter.emit(event);
}
